import { gql } from '@apollo/client';

export const SALE_CORE_FIELDS = `
  fragment SaleCoreFields on Sale {
    id
    name
    saleOn
    preBidOpenAt
    startAt
    endAt
    status
    bidding
    biddingNotice
    bidGroupChoiceId
    bidGroupBuyerId
    biddingFlash
    biddingFlashBackgroundColor
    biddingFlashForegroundColor
    biddingFlashFades
    saleType
    countdownTimeMs
  }
`;

export const SALES = gql`
  ${SALE_CORE_FIELDS}
  query Sales {
    sales {
      ...SaleCoreFields
      visibleSaleAssetsCount
      previewPhotoUrls(limit: 5)
    }
  }
`;

export const SALE = gql`
  ${SALE_CORE_FIELDS}
  query Sale($id: ID!) {
    sale(id: $id) {
      ...SaleCoreFields
      visibleSaleAssetsCount
    }
  }
`;

// Named apart from the bidding room's SaleUpdated so the two don't overwrite
// each other's subscription_queries row; the trigger keys on the field and id,
// so both still get the push. el-api builds the payload from el-auction's
// BiddingSaleFields rather than this selection, so nothing outside that
// fragment can be asked for here.
export const SALE_ACTIVATED = gql`
  subscription SaleActivated($id: ID!) {
    saleUpdated(id: $id) {
      sale {
        id
        status
        bidding
      }
    }
  }
`;

export const REGISTER_FOR_SALE = gql`
  mutation RegisterForSale(
    $id: ID!
  ) {
    createSaleBuyerUser(
      id: $id
    ) {
      saleBuyerUser { id, tcSignOffAt }
      errors { path, message }
    }
  }
`;
